import migrateModifier from "~/utils/update/migrations/0.72.0/migrateModifier.js"
import migrateProfile from "~/utils/update/migrations/0.72.0/migrateProfile"
import migrateWeapon from "~/utils/update/migrations/0.72.0/migrateWeapon"

export default function migrate_0_72_0(profile) {
  // Make sure we have a valid profile object
  if (!profile || typeof profile !== "object") {
    console.error("Invalid profile object received for migration", profile)
    return profile || {}
  }

  // Check if this profile has already been migrated to 0.72.0
  // Look for snake_case properties that were added in this migration
  if (
    profile.weapons_selected_melee !== undefined ||
    profile.weapons_selected_ranged !== undefined ||
    profile.order_slain_auto !== undefined ||
    profile.order_slain_model_types !== undefined ||
    profile.computed_keywords !== undefined
  ) {
    //console.log("Profile already migrated to 0.72.0, skipping migration of this profile")
    return profile
  }

  // Make a defensive copy of the profile
  const migratedProfile = migrateProfile(profile)

  // Unit & weapon abilities.
  migratedProfile.units.forEach((unit) => {
    // Unit abilities.
    if (unit.abilities?.length) {
      unit.abilities.forEach((unitAbility) => {
        migrateModifier(unitAbility)
      })
    }

    // Weapon abilities.
    if (!unit.model_types) {
      unit.model_types = []
      return // Skip this unit if model_types is undefined
    }
    for (const modelType of unit.model_types) {
      if (!modelType?.weapons) continue
      for (const weapon of modelType.weapons) {
        migrateWeapon(weapon)
        if (!weapon?.abilities) continue
        weapon.abilities.forEach((weaponAbility) => {
          migrateModifier(weaponAbility)
        })
      }
    }
  })

  // Mark as updated.
  migratedProfile.updateStatus.updated = true

  // Return migrated profile.
  return migratedProfile
}
